import { actionTypes as queueActionTypes } from '~/queue/reducer';
import { actionTypes as draftActionTypes } from '~/drafts/reducer';

import keyWrapper from '@bufferapp/keywrapper';

export const actionTypes = keyWrapper('CALENDAR', {
  SHOULD_REFETCH: 0,
  CLEAR_REFETCH: 0,
  UPDATE_FILTERS: 0,
});

export const initialState = {
  shouldRefetch: false,
  filters: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_FILTERS: {
      return { filters: action.filters };
    }
    case actionTypes.CLEAR_REFETCH: {
      return { shouldRefetch: false };
    }
    case queueActionTypes.SHOULD_REFETCH:
    case draftActionTypes.DRAFT_CREATED:
    case draftActionTypes.DRAFT_UPDATED:
    case draftActionTypes.DRAFT_DELETED:
    case draftActionTypes.DRAFT_APPROVED:
    case draftActionTypes.DRAFT_MOVED:
    case queueActionTypes.POST_DELETED:
    case queueActionTypes.POST_UPDATED:
    case queueActionTypes.POST_SENT:
    case queueActionTypes.POST_CREATED: {
      return { shouldRefetch: true };
    }
    default:
      return state;
  }
};

export const actions = {
  shouldRefetch: () => ({
    type: actionTypes.SHOULD_REFETCH,
  }),
  clearShouldRefetch: () => ({
    type: actionTypes.CLEAR_REFETCH,
  }),
  updateFilters: ({ filters }) => ({
    type: actionTypes.UPDATE_FILTERS,
    filters,
  }),
};
